// BM-H398 - guide G-3, marriage in contemplation. Its own step in the flow,
// writing the `s1_testator.in_contemplation_of_marriage` block the engine
// reads for C-03. One writer per piece of state (S1Testator owns the key and
// hands this block down), one presentation home per guide section.
//
// BM-H3380 - marriage (Wills Act 1837 s.18(3)) and civil partnership
// (s.18B(3)) are parallel but separate statutory provisions, so C-03 needs
// to know which event is contemplated before it can pick a clause variant.

import { QuestionRow, SectionIntro, Select, TextInput, YesNo } from "./fields";

const EVENT_TYPE_OPTIONS = [
  { value: "marriage", label: "Marriage" },
  { value: "civil_partnership", label: "Civil partnership" },
];

export default function G3MarriageInContemplation({ section, setSection }) {
  const m = section.in_contemplation_of_marriage || {};
  const set = (patch) => setSection({ ...section, in_contemplation_of_marriage: { ...m, ...patch } });

  return (
    <div data-testid="section-g3_marriage">
      <SectionIntro title="Marriage in contemplation">
        This section only applies if you are engaged to be married or planning to enter a civil partnership. If you are not, answer no and we skip it.
      </SectionIntro>
      <QuestionRow qid="s1_testator.in_contemplation_of_marriage.engaged" label="Are you making this will in contemplation of a specific marriage or civil partnership?">
        <YesNo testid="g3-engaged" value={m.engaged} onChange={(v) => set({ engaged: v })} />
      </QuestionRow>
      {m.engaged === true && (
        <>
          <QuestionRow qid="s1_testator.in_contemplation_of_marriage.event_type" label="Is it a marriage or a civil partnership?">
            <Select testid="g3-event-type" value={m.event_type ?? null} options={EVENT_TYPE_OPTIONS} onChange={(v) => set({ event_type: v || null })} />
          </QuestionRow>
          <QuestionRow qid="s1_testator.in_contemplation_of_marriage.intended_spouse_full_name" label="Who are you marrying or entering the civil partnership with?">
            <TextInput testid="g3-intended-spouse" value={m.intended_spouse_full_name} onChange={(v) => set({ intended_spouse_full_name: v || null })} />
          </QuestionRow>
          <QuestionRow qid="s1_testator.in_contemplation_of_marriage.intended_to_survive_marriage" label="Do you want this will to continue to apply after the marriage or civil partnership?">
            <YesNo testid="g3-survive" value={m.intended_to_survive_marriage} onChange={(v) => set({ intended_to_survive_marriage: v })} />
          </QuestionRow>
          <QuestionRow qid="s1_testator.in_contemplation_of_marriage.expected_date" label="Roughly when do you expect the ceremony to take place?">
            <TextInput testid="g3-expected-date" type="month" value={m.expected_date} onChange={(v) => set({ expected_date: v || null })} />
          </QuestionRow>
        </>
      )}
    </div>
  );
}
